<span style="float: left; display: inline-block; position: relative; top: 4px; left: -2px" *ngIf="fromLabel">From:</span>
<div style="float:left;" [ngStyle]="{'opacity': disabled ? '0.5' : '1'}">
    <div class="input-group">
        <input #startDateRef 
                type="text" 
                [disabled]="disabled" 
                [class.has-error]="!startDateValid"
               placeholder="mm/dd/yyyy" 
               maxlength="10" 
               [ngStyle]="{'font-size' : !startDate ? '14px' : '15px'}"
               (keyup)="onStartDateKeyup()" 
               (keyup.enter)="handleBlur($event)"
               (focus)="close()" 
               (blur)="onExitDateInput('start')" 
               class="{{small ? 'small' : ''}}">
        <span class="input-group-addon datepicker {{small ? 'small-icon' : ''}}" [class.has-error]="!startDateValid">
            <i class="bi-calendar-week-fill" (click)="!disabled && (showStartPicker = !showStartPicker); showEndPicker = false">
            </i>
        </span>
    </div>
    <div *ngIf="showStartPicker"
         style="position: absolute; z-index:11; min-height:290px;">
         <bs-datepicker-inline ngDefaultControl
                    [(ngModel)]="startDate"
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    [bsConfig]="{ showWeekNumbers: false }"
                    (bsValueChange)="datePicked($event, 'start')">
        </bs-datepicker-inline>
    </div>
</div>

<span *ngIf="fromLabel" style="float: left; display: inline-block; position: relative; top: 4px; left: -2px">To:</span>
<span *ngIf="!fromLabel" style="float: left; display: inline-block; padding: 10px; position: relative; top: 4px; left: -2px">to</span>


<div style="float:left;" [ngStyle]="{'opacity': disabled ? '0.5' : '1'}">
    <div class="input-group">
        <input #endDateRef type="text" [disabled]="disabled" [class.has-error]="!endDateValid"
               placeholder="mm/dd/yyyy" maxlength="10" [ngStyle]="{'font-size' : !endDate ? '14px' : '15px'}"
               (keyup)="onEndDateKeyup()" (keyup.enter)="handleBlur($event)"
               (focus)="close()" (blur)="onExitDateInput('end')" class="{{small ? 'small' : ''}}">
        <span class="input-group-addon datepicker {{small ? 'small-icon' : ''}}" [class.has-error]="!endDateValid">
                <i class="bi-calendar-week-fill" (click)="!disabled && (showEndPicker = !showEndPicker); showStartPicker = false"></i>
            </span>
    </div>
    <div *ngIf="showEndPicker"
         style="position: absolute; z-index:11; min-height:290px;">
        <bs-datepicker-inline ngDefaultControl
                    [(ngModel)]="endDate"
                    [minDate]="minDate"
                    [maxDate]="maxDate"
                    [bsConfig]="{ showWeekNumbers: false }"
                    (bsValueChange)="datePicked($event, 'end')">
        </bs-datepicker-inline>
    </div>
</div>
